import script from "./ReviewsFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsFeed.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsFeed.vue?vue&type=style&index=0&id=2b316f3e&lang=scss"

const __exports__ = script;

export default __exports__